export function preferencesRxartSecureJson (language) {
  let items

  if (language === 'es') {
    items = {
      parameters: { // Parámetros
        name: 'parameters',
        label: 'configuración de los parámetros'
      },
      messages: { // Mensajes
        name: 'messages',
        label: 'configuración de los mensajes'
      }
    }
  } else if (language === 'en') {
    items = {
      parameters: { // Parámetros
        name: 'parameters',
        label: 'parameter settings'
      },
      messages: { // Mensajes
        name: 'messages',
        label: 'messages settings'
      }
    }
  }
  return (items)
}
